<div id="pageContainer" class="fullscreen-mode">
  <p-dialog [(visible)]="work" modal [header]="('mobile-status.mobile-worklist.updateWork' | translate) + ' #' + work?.id"
            [style]="{ width: '100vw',   'height': '100%',
    'max-height': '100%' }" [closable]="false">
    <form [formGroup]="form">
      <div class="p-fluid">
        <div class="p-field">
          <label for="title">
            {{ 'mobile-status.mobile-worklist.workTitle' | translate }}
            <span class="p-error">*</span>
          </label>
          <input type="text" formControlName="title" class="form-control" />
          <small class="text-danger" *ngIf="form.get('title')?.touched && form.get('title')?.invalid">
            {{ 'mobile-status.mobile-worklist.workTitleInvalid' | translate }}
          </small>
        </div>

        <div class="p-field">
          <label for="description">{{ 'mobile-status.mobile-worklist.description' | translate }}</label>
          <textarea formControlName="description" class="form-control" rows="3"></textarea>
          <small class="text-danger" *ngIf="form.get('description')?.touched && form.get('description')?.invalid">
            {{ 'mobile-status.mobile-worklist.workDescInvalid' | translate }}
          </small>
        </div>

        <div class="p-grid">
          <div class="p-col-6">
            <div class="p-field">
              <label for="workDate">
                {{ 'mobile-status.mobile-worklist.workDate' | translate }}
                <span class="p-error">*</span>
              </label>
              <p-calendar formControlName="workDate" [placeholder]="'mobile-status.mobile-worklist.startDate' | translate"
                          [showTime]="true" [showButtonBar]="true" appendTo="body" [dateFormat]="'dd.mm.yy'" hourFormat="24"
                          [minDate]="minWorkDate" styleClass="custom-calendar" />
              <small class="text-danger" *ngIf="form.get('workDate')?.touched && form.get('workDate')?.invalid">
                {{ 'mobile-status.mobile-worklist.dateInvalid' | translate }}
              </small>
              <small class="text-danger"
                     *ngIf="workDateBeforeAlarmTimeError">
                {{ 'mobile-status.mobile-worklist.controlDates' | translate }}
              </small>
            </div>
          </div>

          <div class="p-col-6">
            <div class="p-field">
              <label for="alarmClokDate">
                {{ 'mobile-status.mobile-worklist.alarmClokDate' | translate }}
                <span class="p-error">*</span>
              </label>
              <p-calendar id="alarmClokDate" formControlName="alarmClokDate"
                          [placeholder]="'mobile-status.mobile-worklist.alarmClokDate' | translate" [showTime]="true" [showButtonBar]="true"
                          appendTo="body" [dateFormat]="'dd.mm.yy'" hourFormat="24" styleClass="custom-calendar"
                          (onSelect)="onAlarmTimeChange()" />
              <small class="text-danger" *ngIf="form.get('alarmClokDate')?.touched && form.get('alarmClokDate')?.invalid">
                {{ 'mobile-status.mobile-worklist.dateInvalid' | translate }}
              </small>
            </div>
          </div>
        </div>

        <div class="p-grid">
          <div class="p-col-6">
            <div class="p-field">
              <label for="priority">{{ 'mobile-status.mobile-worklist.priority' | translate }}</label>
              <p-dropdown [options]="priorityOptions" optionLabel="label" optionValue="value" formControlName="priority" [showClear]="true"
                          appendTo="body"></p-dropdown>
            </div>
          </div>

          <div class="p-col-6">
            <div class="p-field">
              <label for="teams">
                {{ 'mobile-status.mobile-worklist.teams' | translate }}
                <span class="p-error">*</span>
              </label>
              <p-multiSelect [options]="teamsOptions" formControlName="teams" optionLabel="label" optionValue="value"
                             appendTo="body"></p-multiSelect>
              <small class="text-danger" *ngIf="form.get('teams')?.touched && form.get('teams')?.invalid">
                {{ 'mobile-status.mobile-worklist.teamInvalid' | translate }}
              </small>
            </div>
          </div>
        </div>

        <div class="p-grid">
          <div class="p-col-6">
            <div class="p-field">
              <label for="status">{{ 'mobile-status.mobile-worklist.status' | translate }}</label>
              <div class="p-inputgroup">
                <p-dropdown [options]="statusOptions" optionLabel="label" optionValue="value" formControlName="status"
                            appendTo="body"></p-dropdown>
                <button type="button" pButton icon="pi pi-history" class="p-button-outlined p-button-secondary"
                        (click)="openStatusLogsDialog()" [pTooltip]="'mobile-status.mobile-worklist.statusHistory' | translate"
                        tooltipPosition="top"></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>

    <!-- Footer -->
    <ng-template pTemplate="footer">
      <button type="button" class="btn btn-secondary me-2" (click)="cancel()">
        {{ 'common.close' | translate }}
      </button>
      <button type="button" class="btn btn-primary" (click)="save()">
        {{ 'mobile-status.mobile-worklist.update' | translate }}
      </button>
    </ng-template>
  </p-dialog>


  <p-dialog [(visible)]="statusLogsVisible" modal [header]="'mobile-status.mobile-worklist.statusHistory' | translate"
            [style]="{ width: '60vw' }">
    <div class="status-history-container">
      <p-timeline [value]="statusLogs" align="alternate" styleClass="customized-timeline">
        <ng-template pTemplate="marker" let-statusLog>
        <span class="custom-marker">
          <i class="pi pi-circle-fill"></i>
        </span>
        </ng-template>

        <ng-template pTemplate="content" let-statusLog>
          <div class="timeline-content">
            <div class="status-change">
              <span class="old-status">{{ statusLog.oldStatusName }}</span>
              <i class="pi pi-arrow-right mx-2"></i>
              <span class="new-status">
              {{ statusLog.newStatusName }}
            </span>
            </div>
            <div class="change-details">
              <div class="user-info">
                <i class="pi pi-user"></i>
                <span> <b>{{'mobile-status.mobile-worklist.processUser' | translate}} </b>{{ statusLog.user?.name }}</span>
              </div>
              <div class="date-info">
                <i class="pi pi-calendar"></i>
                <span><b>{{'mobile-status.mobile-worklist.processDate' | translate}} </b> {{ statusLog.changedAt | date: 'dd.MM.yyyy
                  HH:mm' }}</span>
              </div>
            </div>
            <div class="change-note" *ngIf="statusLog.note">
              <i class="pi pi-comment"></i>
              <span>{{ statusLog.note }}</span>
            </div>
          </div>
        </ng-template>
      </p-timeline>

      <div class="no-history" *ngIf="!statusLogs ?? statusLogs.length === 0">
        <i class="pi pi-info-circle"></i>
        <span>{{'mobile-status.mobile-worklist.nonStatusHistory' | translate}}</span>
      </div>
    </div>

    <ng-template pTemplate="footer">
      <button type="button" class="btn btn-secondary" (click)="closeStatusLogsDialog()">
        {{'mobile-status.mobile-worklist.close' | translate}}
      </button>
    </ng-template>
  </p-dialog>
</div>
